import { setDefaultLocale } from 'react-datepicker';
import I18n from 'i18n-js';

import { setApiLanguage } from '@lootboy/lib';
import user from '@lootboy/lib/actions/UserActions';
import { LANGUAGES } from '@lootboy/translations/config';

import { loadTranslationAsynchronously } from '~/i18n';

export function setLanguage(lang) {
  return async (dispatch, getState) => {
    const languagePersisted = getState().auth.language;
    const language = LANGUAGES.find((l) => new RegExp(`^${l}(-|$)`).test(lang));
    if (language && (languagePersisted || I18n.locale) !== language) {
      await loadTranslationAsynchronously(language);
      I18n.locale = language;
      setApiLanguage(I18n.locale);
      setDefaultLocale(language);
      dispatch(user.setLanguage(language));
    }
  };
}

export default {
  setLanguage,
};
